<div class="semaforo">
    <div class="luz rojo"></div>
    <div class="luz amarillo"></div>
    <div class="luz verde"></div>
  </div>
  